import React from 'react'
import { Link } from "@reach/router"
import interact from 'interactjs'

import About from './../About/About'
import Navigation from './../Navigation/Navigation'


import './MobileModel.scss'

import gsap from 'gsap'

import { useIdleTimer } from 'react-idle-timer'

// scene elements
import L00_sky from './assets/00-sky.gif'
import L00_ground from './assets/00-ground.gif'

import L01_landscape from './assets/01-landscape.gif'
import L01_sea from './assets/01-sea.gif'

import L01_zattera from './assets/01-zattera.png'
import L01_rock_dx from './assets/01-rock-dx.gif'

import L02_model from './assets/02-model.gif'
import L02_smoke from './assets/02-smoke.gif'

import M_01 from './assets/model-mobile1.png'
import M_02 from './assets/model-mobile2.png'
import M_03 from './assets/model-mobile3.png'
import M_04 from './assets/model-mobile4.png'
import M_05 from './assets/model-mobile5.png'
import M_06 from './assets/model-mobile6.png'
import M_07 from './assets/model-mobile7.png'
import M_08 from './assets/model-mobile8.png'
import M_09 from './assets/model-mobile9.png'
import M_10 from './assets/model-mobile10.png'
import M_11 from './assets/model-mobile11.png'
import M_12 from './assets/model-mobile12.png'

import L03_hole_cx from './assets/03-hole-cx.gif'
import L03_rock_dx_old from './assets/03-rock-dx-old.gif'
import L03_rock_sx from './assets/03-rock-sx.gif'

// contributions
import contrib_01 from './../contributions/01_abnormal.gif'
import contrib_02 from './../contributions/02_lootsma.gif'
import contrib_03 from './../contributions/03_foster.gif'
import contrib_04 from './../contributions/04_fala.gif'
import contrib_05 from './../contributions/05_wai.gif'
import contrib_06 from './../contributions/06_microcities.gif'
import contrib_07 from './../contributions/07_fosbury.gif'
import contrib_08 from './../contributions/08_bose_hellberg_lesmes.gif'
import contrib_09 from './../contributions/09_ghidoni.gif'
import contrib_10 from './../contributions/10_antonas.gif'
import contrib_11 from './../contributions/11_maio.gif'
import contrib_12 from './../contributions/12_traumnovelle.gif'

const MobileModel = ({aboutVisibility, setAboutVisibility, isOpen, data, controlAudio, setControlAudio, ...rest}) => {
    const controls = React.useRef( null )
    const scene = React.useRef( null )

    const [ isBig, setIsBig ] = React.useState( false )
    const [ scroll, _setScroll ] = React.useState( {
        top: 0,
        left: 0
    } )
    const scrollRef = React.useRef( scroll )

    const setScroll = data => {
        scrollRef.current = data
        _setScroll( data )
    }

    React.useEffect( () => {
        !isOpen &&
            !controlAudio &&
                setControlAudio( true )
    }, [] ) 

    // /**
    //  * Move event
    //  * @param {*} dx 
    //  * @param {*} dy 
    //  */
    // const moveHandler = ( dx, dy ) => {
    //     console.log(( scene.current.scrollHeight - window.innerHeight ) * -1)
    //     scrollRef.current.top = scrollRef.current.top + dy 
    //     scrollRef.current.top = Math.abs( scrollRef.current.top ) <= scene.current.scrollHeight - window.innerHeight
    //         ? scrollRef.current.top < 0 
    //             ? scrollRef.current.top 
    //             : 0 
    //         : ( scene.current.scrollHeight - window.innerHeight ) * -1


    //     scrollRef.current.left = scrollRef.current.left + dx 
    //     scrollRef.current.left = Math.abs( scrollRef.current.left ) <= scene.current.scrollWidth - window.innerWidth
    //         ? scrollRef.current.left < 0 
    //             ? scrollRef.current.left 
    //             : 0
    //         : ( scene.current.scrollWidth - window.innerWidth ) * -1

    //     gsap.to( scene.current, { 
    //         duration: .7, 
    //         y: scrollRef.current.top,
    //         x: scrollRef.current.left
    //     } )
    // }

    /**
     * Interact event handling
     */
    // React.useEffect( () => {
    //     let initialDistance

    //     interact( controls.current )
    //         .gesturable( {
    //             onstart: (event) => {
    //                 initialDistance = event.distance
    //             },
                
    //             onmove: (event) => {
    //                 if ( initialDistance < event.distance ) {
    //                     console.log( `zoom in` )
    //                     setIsBig( true )
    //                 } else {
    //                     console.log( `zoom out` )
    //                     setIsBig( false )
    //                 }
    //             },

    //             onend: (event) => {
    //                 initialDistance = event.distance 
    //             }
    //         })
    //         .draggable( {
    //             inertia: false,
    //             onmove: event => moveHandler( event.dx * .7, event.dy * .7 )
    //         } )

    // }, [] )

    /*
        Idle timer
    */
    // const [isIdle,setIsIdle] = React.useState( false );

    // const handleOnIdle = () => {
    //     console.log('user is idle', isIdle)
    //     setIsIdle( true )
    //   }
     
    //   const handleOnActive = () => {
    //     setIsIdle( false )
    //     console.log('user is active', isIdle)
    //   }
     
    //   const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    //     timeout: 6000,
    //     onIdle: handleOnIdle,
    //     onActive: handleOnActive,
    //     debounce: 500
    //   })


    //   /*
    //     Timeout for Link
    //   */
    //   const [isTime, setIsTime] = React.useState(false)

    //   React.useEffect(() => {
    //       if (isBig) {
    //         let timerLink = setTimeout( () => setIsTime(true), 700)
    //         return () => clearTimeout(timerLink)
    //       } else {
    //           setIsTime(false)
    //       }  
    //   }, [isBig] )




    /**
     * Zoom animation
     */
    // React.useEffect( () => {
    //     isBig 
    //         ? gsap.to( scene.current, { duration: .6, 
    //             height: `200%`,
    //             x: 0,
    //             y: 0,
    //          })
            
    //         : gsap.to( scene.current, { duration: .6, 
    //             height: `100%`,
    //             x: 0,
    //             y: 0, 
    //          })

    //     setScroll( {
    //         top: 0,
    //         left: 0, 
    //     } )
    // }, [ isBig ] )

    return(
        <div ref={ scene } className={ [ `mobile-model`, `${ isBig ? `mobile-model--is-big` : `mobile-model--not-big` }`, `${ isOpen ? `mobile-model--posterize` : 'mobile-model--normal' }`].join( ` ` ) } >

            {/* <div className={`_text ux-notice ${ !isOpen && !aboutVisibility && isIdle ? `ux-notice--visible` : `ux-notice--hidden`}`}>
                <span>Pinch to zoom</span>
            </div> */}

            <svg className={`model-stage`} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1280.37 1997.75">
            <filter id="posterize" filterRes="512">
                    <feComponentTransfer>
                        <feFuncR type="discrete" tableValues="0 1 1 1" />
                        <feFuncG type="discrete" tableValues="0 1 1 1" />
                        <feFuncB type="discrete" tableValues="0 0 0 0" />
                    </feComponentTransfer>
                </filter> 
            <g id="sky">
                <image id="image" width="2298" height="2105" transform="translate(0 0) scale(0.56 0.38)" xlinkHref={L00_sky}/>
            </g>
            <g id="ground">
                <image id="image-2" data-name="image" width="2298" height="2313" transform="translate(0 1000.3) scale(0.56 0.57)" xlinkHref={L00_ground}/>
            </g>
            <g id="background">
                <image id="sea" width="2298" height="296" transform="translate(0 744.4) scale(0.56)" xlinkHref={L01_sea}/>
                <image id="land" width="2298" height="276" transform="translate(0 909.39) scale(0.56)" xlinkHref={L01_landscape}/>
                <image id="raft" width="129" height="163" transform="translate(1158.82 733.96) scale(0.56 0.56)" xlinkHref={L01_zattera}/>
                <image id="rock-dx" width="794" height="604" transform="translate(786.62 944.26) scale(0.62 0.62)" xlinkHref={L01_rock_dx}/>
                {/* <image id="cloud" width="1987" height="803" transform="translate(0 0) scale(0.43)" xlinkHref={L01_cloud}/> */}
            </g>
            <g id="midground">
                <image id="model"  width="1602" height="1638" transform="translate(156.06 425.23) scale(0.58 0.58)" xlinkHref={L02_model}/>
                <g id="windows">
                    <foreignObject id="c01" x="312.25" y="557.69" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_01 } /></foreignObject>
                    <image id="n01" className={`number`} width="23" height="43" transform="translate(373.07 742.93) scale(0.58 0.58)" xlinkHref={M_01}/>
                    <foreignObject id="c02" x="495.79" y="557.67" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_02 } /></foreignObject>
                    <image id="n02" className={`number`} width="38" height="45" transform="translate(539.79 741.76) scale(0.58 0.58)" xlinkHref={M_02}/>
                    <foreignObject id="c03" x="678.82" y="557.67" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_03 } /></foreignObject>
                    <image id="n03" className={`number`} width="27" height="45" transform="translate(723.27 737.69) scale(0.58 0.58)" xlinkHref={M_03}/>
                    <foreignObject id="c04" x="857.97" y="557.69" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_04 } /></foreignObject>
                    <image id="n04" className={`number`} width="48" height="64" transform="translate(872.65 734.94) scale(0.58 0.58)" xlinkHref={M_04}/>
                    
                    <foreignObject id="c05" x="312.26" y="820.77" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_05 } /></foreignObject>
                    <image id="n05" className={`number`} width="36" height="51" transform="translate(365.5 1007.17) scale(0.58 0.58)" xlinkHref={M_05}/>
                    <foreignObject id="c06" x="495.78" y="820.77" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_06 } /></foreignObject>
                    <image id="n06" className={`number`} width="44" height="41" transform="translate(535.57 1003.51) scale(0.58 0.58)" xlinkHref={M_06}/>
                    <foreignObject id="c07" x="678.83" y="820.77" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_07 } /></foreignObject>
                    <image id="n07" className={`number`} width="38" height="41" transform="translate(702.44 1007.18) scale(0.58 0.58)" xlinkHref={M_07}/>
                    <foreignObject id="c08" x="857.97" y="820.74" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_08 } /></foreignObject>
                    <image id="n08" className={`number`} width="27" height="60" transform="translate(883.73 1011.82) scale(0.58 0.58)" xlinkHref={M_08}/>
                    
                    <foreignObject id="c09" x="311.66" y="1085.02" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_09 } /></foreignObject>
                    <image id="n09" className={`number`} width="32" height="37" transform="translate(360.83 1279.16) scale(0.58 0.58)" xlinkHref={M_09}/>
                    <foreignObject id="c10" x="495.58" y="1085.61" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image` } alt={`unfolding pavilion project`} src={ contrib_10 } /></foreignObject>
                    <image id="n10" className={`number`} width="83" height="57" transform="translate(510.66 1268.66) scale(0.58 0.58)" xlinkHref={M_10}/>
                    <foreignObject id="c11" x="678.89" y="1085.62" width="106.64" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image` } alt={`unfolding pavilion project`} src={ contrib_11 } /></foreignObject>
                    <image id="n11" className={`number`} width="52" height="66" transform="translate(699.1 1269.08) scale(0.58 0.58)" xlinkHref={M_11}/>
                    <foreignObject id="c12" x="858" y="1085.62" width="106.07" height="158" style={{fill: 'none'}}><img className={ `mobile-model-link-image contribution` } alt={`unfolding pavilion project`} src={ contrib_12 } /></foreignObject>
                    <image id="n12" className={`number`} width="75" height="46" transform="translate(862.9 1274.5) scale(0.58 0.58)" xlinkHref={M_12}/>
                </g>
                <image id="smoke" width="737" height="671" transform="translate(522.09 126.79) scale(0.47)" xlinkHref={L02_smoke}/>
            </g>
            <g id="foreground">
                <image id="hole-square" width="864" height="245" transform="translate(463.56 1544.62) scale(0.66 0.66)" xlinkHref={L03_hole_cx}/>
                <image id="rock-round-sx" width="592" height="952" transform="translate(0 1397.63) scale(0.56 0.56)" xlinkHref={L03_rock_sx}/>
                <image id="rock-dx-2" data-name="rock-dx" width="652" height="1038" transform="translate(981.46 1522.47) scale(0.46)" xlinkHref={L03_rock_dx_old}/>
            </g>
            </svg>

            <svg ref={ controls } className={ [ `model-links-overlay`, `model-links-overlay--${ isBig ? `is-big` : `not-big` }` ].join( ` ` ) } xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1280.37 1997.75" preserveAspectRatio="xMaxYMid meet">
                <g id="windows-transparent">
                <foreignObject className={ `mobile-model-window` }  id="w01" x="312.25" y="558.69" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room01` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w02" x="498.79" y="558.67" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room02` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w03" x="681.82" y="558.67" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room03` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w04" x="861.97" y="558.69" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room04` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w05" x="312.26" y="822.77" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room05` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w06" x="498.78" y="822.77" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room06` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w07" x="681.83" y="822.77" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room07` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w08" x="861.97" y="822.74" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room08` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w09" x="311.66" y="1088.02" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room09` } /> 

                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w10" x="498.78" y="1088.61" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room10` } />
                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w11" x="681.89" y="1088.62" width="106.64" height="158" style={{fill: 'none'}}>
                <Link to={ `/room11` } />

                </foreignObject>
                <foreignObject className={ `mobile-model-window window` }  id="w12" x="862" y="1088.62" width="106.07" height="158" style={{fill: 'none'}}>
                <Link to={ `/room12` } />
                </foreignObject>

                <foreignObject className={ `mobile-model-window window` }  id="w13" x="990.97" y="488.69" width="65.07" height="65" style={{fill: 'red'}}>
                    <a target="_blank" href={'https://unfoldingpavilion.com/'}>
                    </a>
                </foreignObject>
                </g>
            </svg>

            <About isClosed={ !aboutVisibility } data={data} ></About>
            <Navigation isActive={ aboutVisibility } visible={ !isOpen } onClick={() => setAboutVisibility( !aboutVisibility ) } />

        </div>
    )
}

export default MobileModel